/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';

import { WorkCreateMessagingTemplateDto } from '../models/work-create-messaging-template-dto';
import { WorkMessagingTemplate } from '../models/work-messaging-template';
import { WorkMessagingTemplateFunctionsOverviewDto } from '../models/work-messaging-template-functions-overview-dto';
import { WorkPaginatedDocumented } from '../models/work-paginated-documented';
import { WorkUpdateMessagingTemplateDto } from '../models/work-update-messaging-template-dto';

@Injectable({ providedIn: 'root' })
export class WorkMessagingTemplatesV2Service extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `messagingTemplatesV2ControllerGetAvailableVariables()` */
  static readonly MessagingTemplatesV2ControllerGetAvailableVariablesPath = '/v2/messaging-templates/variables';

  /**
   * Required permissions: messaging-templates:read, messaging-templates:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `messagingTemplatesV2ControllerGetAvailableVariables()` instead.
   *
   * This method doesn't expect any request body.
   */
  messagingTemplatesV2ControllerGetAvailableVariables$Response(
    params?: {
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<Array<string>>> {
    const rb = new RequestBuilder(this.rootUrl, WorkMessagingTemplatesV2Service.MessagingTemplatesV2ControllerGetAvailableVariablesPath, 'get');
    if (params) {
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<string>>;
      })
    );
  }

  /**
   * Required permissions: messaging-templates:read, messaging-templates:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `messagingTemplatesV2ControllerGetAvailableVariables$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  messagingTemplatesV2ControllerGetAvailableVariables(
    params?: {
    },
    context?: HttpContext
  ): Observable<Array<string>> {
    return this.messagingTemplatesV2ControllerGetAvailableVariables$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<string>>): Array<string> => r.body)
    );
  }

  /** Path part for operation `messagingTemplatesV2ControllerGetFunctionsOverview()` */
  static readonly MessagingTemplatesV2ControllerGetFunctionsOverviewPath = '/v2/messaging-templates/function-bindings';

  /**
   * Required permissions: messaging-templates:read, messaging-templates:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `messagingTemplatesV2ControllerGetFunctionsOverview()` instead.
   *
   * This method doesn't expect any request body.
   */
  messagingTemplatesV2ControllerGetFunctionsOverview$Response(
    params?: {
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<WorkMessagingTemplateFunctionsOverviewDto>> {
    const rb = new RequestBuilder(this.rootUrl, WorkMessagingTemplatesV2Service.MessagingTemplatesV2ControllerGetFunctionsOverviewPath, 'get');
    if (params) {
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WorkMessagingTemplateFunctionsOverviewDto>;
      })
    );
  }

  /**
   * Required permissions: messaging-templates:read, messaging-templates:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `messagingTemplatesV2ControllerGetFunctionsOverview$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  messagingTemplatesV2ControllerGetFunctionsOverview(
    params?: {
    },
    context?: HttpContext
  ): Observable<WorkMessagingTemplateFunctionsOverviewDto> {
    return this.messagingTemplatesV2ControllerGetFunctionsOverview$Response(params, context).pipe(
      map((r: StrictHttpResponse<WorkMessagingTemplateFunctionsOverviewDto>): WorkMessagingTemplateFunctionsOverviewDto => r.body)
    );
  }

  /** Path part for operation `messagingTemplatesV2ControllerRepairFunctionBindings()` */
  static readonly MessagingTemplatesV2ControllerRepairFunctionBindingsPath = '/v2/messaging-templates/function-bindings/repair';

  /**
   * Required permissions: messaging-templates:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `messagingTemplatesV2ControllerRepairFunctionBindings()` instead.
   *
   * This method doesn't expect any request body.
   */
  messagingTemplatesV2ControllerRepairFunctionBindings$Response(
    params?: {
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<WorkMessagingTemplateFunctionsOverviewDto>> {
    const rb = new RequestBuilder(this.rootUrl, WorkMessagingTemplatesV2Service.MessagingTemplatesV2ControllerRepairFunctionBindingsPath, 'post');
    if (params) {
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WorkMessagingTemplateFunctionsOverviewDto>;
      })
    );
  }

  /**
   * Required permissions: messaging-templates:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `messagingTemplatesV2ControllerRepairFunctionBindings$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  messagingTemplatesV2ControllerRepairFunctionBindings(
    params?: {
    },
    context?: HttpContext
  ): Observable<WorkMessagingTemplateFunctionsOverviewDto> {
    return this.messagingTemplatesV2ControllerRepairFunctionBindings$Response(params, context).pipe(
      map((r: StrictHttpResponse<WorkMessagingTemplateFunctionsOverviewDto>): WorkMessagingTemplateFunctionsOverviewDto => r.body)
    );
  }

  /** Path part for operation `messagingTemplatesV2ControllerFindAllPaginated()` */
  static readonly MessagingTemplatesV2ControllerFindAllPaginatedPath = '/v2/messaging-templates';

  /**
   * Required permissions: messaging-templates:read, messaging-templates:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `messagingTemplatesV2ControllerFindAllPaginated()` instead.
   *
   * This method doesn't expect any request body.
   */
  messagingTemplatesV2ControllerFindAllPaginated$Response(
    params?: {

    /**
     * Page number to retrieve.If you provide invalid value the default page number will applied
     *         <p>
     *              <b>Example: </b> 1
     *           </p>
     *         <p>
     *              <b>Default Value: </b> 1
     *           </p>
     */
      page?: number;

    /**
     * Number of records per page.
     *       <p>
     *              <b>Example: </b> 20
     *           </p>
     *       <p>
     *              <b>Default Value: </b> 25
     *           </p>
     *       <p>
     *              <b>Max Value: </b> 100
     *           </p>
     *
     *       If provided value is greater than max value, max value will be applied.
     */
      limit?: number;

    /**
     * Parameter to sort by.
     *       <p>To sort by multiple fields, just provide query param multiple types. The order in url defines an order of sorting</p>
     *       <p>
     *              <b>Format: </b> fieldName:DIRECTION
     *           </p>
     *       <p>
     *              <b>Example: </b> sortBy=id:DESC&sortBy=createdAt:ASC
     *           </p>
     *       <p>
     *              <b>Default Value: </b> name:ASC
     *           </p>
     *       <h4>Available Fields</h4><ul><li>id</li>
     * <li>name</li>
     * <li>mailSubject</li>
     * <li>functionKey</li>
     * <li>variantKey</li></ul>
     */
      sortBy?: Array<'id:ASC' | 'id:DESC' | 'name:ASC' | 'name:DESC' | 'mailSubject:ASC' | 'mailSubject:DESC' | 'functionKey:ASC' | 'functionKey:DESC' | 'variantKey:ASC' | 'variantKey:DESC'>;

    /**
     * Search term to filter result values
     *         <p>
     *              <b>Example: </b> John
     *           </p>
     *         <p>
     *              <b>Default Value: </b> No default value
     *           </p>
     */
      search?: string;

    /**
     * List of fields to search by term to filter result values
     *         <p>
     *              <b>Example: </b> name,mailSubject,message,functionKey
     *           </p>
     *         <p>
     *              <b>Default Value: </b> By default all fields mentioned below will be used to search by term
     *           </p>
     *         <h4>Available Fields</h4><ul><li>name</li>
     * <li>mailSubject</li>
     * <li>message</li>
     * <li>functionKey</li></ul>
     */
      searchBy?: Array<string>;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<WorkPaginatedDocumented & {
'data'?: Array<WorkMessagingTemplate>;
'meta'?: {
'select'?: Array<string>;
'filter'?: {
};
};
}>> {
    const rb = new RequestBuilder(this.rootUrl, WorkMessagingTemplatesV2Service.MessagingTemplatesV2ControllerFindAllPaginatedPath, 'get');
    if (params) {
      rb.query('page', params.page, {});
      rb.query('limit', params.limit, {});
      rb.query('sortBy', params.sortBy, {});
      rb.query('search', params.search, {});
      rb.query('searchBy', params.searchBy, {});
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WorkPaginatedDocumented & {
        'data'?: Array<WorkMessagingTemplate>;
        'meta'?: {
        'select'?: Array<string>;
        'filter'?: {
        };
        };
        }>;
      })
    );
  }

  /**
   * Required permissions: messaging-templates:read, messaging-templates:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `messagingTemplatesV2ControllerFindAllPaginated$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  messagingTemplatesV2ControllerFindAllPaginated(
    params?: {

    /**
     * Page number to retrieve.If you provide invalid value the default page number will applied
     *         <p>
     *              <b>Example: </b> 1
     *           </p>
     *         <p>
     *              <b>Default Value: </b> 1
     *           </p>
     */
      page?: number;

    /**
     * Number of records per page.
     *       <p>
     *              <b>Example: </b> 20
     *           </p>
     *       <p>
     *              <b>Default Value: </b> 25
     *           </p>
     *       <p>
     *              <b>Max Value: </b> 100
     *           </p>
     *
     *       If provided value is greater than max value, max value will be applied.
     */
      limit?: number;

    /**
     * Parameter to sort by.
     *       <p>To sort by multiple fields, just provide query param multiple types. The order in url defines an order of sorting</p>
     *       <p>
     *              <b>Format: </b> fieldName:DIRECTION
     *           </p>
     *       <p>
     *              <b>Example: </b> sortBy=id:DESC&sortBy=createdAt:ASC
     *           </p>
     *       <p>
     *              <b>Default Value: </b> name:ASC
     *           </p>
     *       <h4>Available Fields</h4><ul><li>id</li>
     * <li>name</li>
     * <li>mailSubject</li>
     * <li>functionKey</li>
     * <li>variantKey</li></ul>
     */
      sortBy?: Array<'id:ASC' | 'id:DESC' | 'name:ASC' | 'name:DESC' | 'mailSubject:ASC' | 'mailSubject:DESC' | 'functionKey:ASC' | 'functionKey:DESC' | 'variantKey:ASC' | 'variantKey:DESC'>;

    /**
     * Search term to filter result values
     *         <p>
     *              <b>Example: </b> John
     *           </p>
     *         <p>
     *              <b>Default Value: </b> No default value
     *           </p>
     */
      search?: string;

    /**
     * List of fields to search by term to filter result values
     *         <p>
     *              <b>Example: </b> name,mailSubject,message,functionKey
     *           </p>
     *         <p>
     *              <b>Default Value: </b> By default all fields mentioned below will be used to search by term
     *           </p>
     *         <h4>Available Fields</h4><ul><li>name</li>
     * <li>mailSubject</li>
     * <li>message</li>
     * <li>functionKey</li></ul>
     */
      searchBy?: Array<string>;
    },
    context?: HttpContext
  ): Observable<WorkPaginatedDocumented & {
'data'?: Array<WorkMessagingTemplate>;
'meta'?: {
'select'?: Array<string>;
'filter'?: {
};
};
}> {
    return this.messagingTemplatesV2ControllerFindAllPaginated$Response(params, context).pipe(
      map((r: StrictHttpResponse<WorkPaginatedDocumented & {
'data'?: Array<WorkMessagingTemplate>;
'meta'?: {
'select'?: Array<string>;
'filter'?: {
};
};
}>): WorkPaginatedDocumented & {
'data'?: Array<WorkMessagingTemplate>;
'meta'?: {
'select'?: Array<string>;
'filter'?: {
};
};
} => r.body)
    );
  }

  /** Path part for operation `messagingTemplatesV2ControllerCreate()` */
  static readonly MessagingTemplatesV2ControllerCreatePath = '/v2/messaging-templates';

  /**
   * Required permissions: messaging-templates:create, messaging-templates:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `messagingTemplatesV2ControllerCreate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  messagingTemplatesV2ControllerCreate$Response(
    params: {
      body: WorkCreateMessagingTemplateDto
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<WorkMessagingTemplate>> {
    const rb = new RequestBuilder(this.rootUrl, WorkMessagingTemplatesV2Service.MessagingTemplatesV2ControllerCreatePath, 'post');
    if (params) {
      rb.body(params.body, 'application/json');
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WorkMessagingTemplate>;
      })
    );
  }

  /**
   * Required permissions: messaging-templates:create, messaging-templates:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `messagingTemplatesV2ControllerCreate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  messagingTemplatesV2ControllerCreate(
    params: {
      body: WorkCreateMessagingTemplateDto
    },
    context?: HttpContext
  ): Observable<WorkMessagingTemplate> {
    return this.messagingTemplatesV2ControllerCreate$Response(params, context).pipe(
      map((r: StrictHttpResponse<WorkMessagingTemplate>): WorkMessagingTemplate => r.body)
    );
  }

  /** Path part for operation `messagingTemplatesV2ControllerFindOneById()` */
  static readonly MessagingTemplatesV2ControllerFindOneByIdPath = '/v2/messaging-templates/{id}';

  /**
   * Required permissions: messaging-templates:read, messaging-templates:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `messagingTemplatesV2ControllerFindOneById()` instead.
   *
   * This method doesn't expect any request body.
   */
  messagingTemplatesV2ControllerFindOneById$Response(
    params: {
      id: number;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<WorkMessagingTemplate>> {
    const rb = new RequestBuilder(this.rootUrl, WorkMessagingTemplatesV2Service.MessagingTemplatesV2ControllerFindOneByIdPath, 'get');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WorkMessagingTemplate>;
      })
    );
  }

  /**
   * Required permissions: messaging-templates:read, messaging-templates:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `messagingTemplatesV2ControllerFindOneById$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  messagingTemplatesV2ControllerFindOneById(
    params: {
      id: number;
    },
    context?: HttpContext
  ): Observable<WorkMessagingTemplate> {
    return this.messagingTemplatesV2ControllerFindOneById$Response(params, context).pipe(
      map((r: StrictHttpResponse<WorkMessagingTemplate>): WorkMessagingTemplate => r.body)
    );
  }

  /** Path part for operation `messagingTemplatesV2ControllerDelete()` */
  static readonly MessagingTemplatesV2ControllerDeletePath = '/v2/messaging-templates/{id}';

  /**
   * Required permissions: messaging-templates:delete, messaging-templates:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `messagingTemplatesV2ControllerDelete()` instead.
   *
   * This method doesn't expect any request body.
   */
  messagingTemplatesV2ControllerDelete$Response(
    params: {
      id: number;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<boolean>> {
    const rb = new RequestBuilder(this.rootUrl, WorkMessagingTemplatesV2Service.MessagingTemplatesV2ControllerDeletePath, 'delete');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: String((r as HttpResponse<any>).body) === 'true' }) as StrictHttpResponse<boolean>;
      })
    );
  }

  /**
   * Required permissions: messaging-templates:delete, messaging-templates:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `messagingTemplatesV2ControllerDelete$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  messagingTemplatesV2ControllerDelete(
    params: {
      id: number;
    },
    context?: HttpContext
  ): Observable<boolean> {
    return this.messagingTemplatesV2ControllerDelete$Response(params, context).pipe(
      map((r: StrictHttpResponse<boolean>): boolean => r.body)
    );
  }

  /** Path part for operation `messagingTemplatesV2ControllerUpdate()` */
  static readonly MessagingTemplatesV2ControllerUpdatePath = '/v2/messaging-templates/{id}';

  /**
   * Required permissions: messaging-templates:update, messaging-templates:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `messagingTemplatesV2ControllerUpdate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  messagingTemplatesV2ControllerUpdate$Response(
    params: {
      id: number;
      body: WorkUpdateMessagingTemplateDto
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<WorkMessagingTemplate>> {
    const rb = new RequestBuilder(this.rootUrl, WorkMessagingTemplatesV2Service.MessagingTemplatesV2ControllerUpdatePath, 'patch');
    if (params) {
      rb.path('id', params.id, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WorkMessagingTemplate>;
      })
    );
  }

  /**
   * Required permissions: messaging-templates:update, messaging-templates:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `messagingTemplatesV2ControllerUpdate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  messagingTemplatesV2ControllerUpdate(
    params: {
      id: number;
      body: WorkUpdateMessagingTemplateDto
    },
    context?: HttpContext
  ): Observable<WorkMessagingTemplate> {
    return this.messagingTemplatesV2ControllerUpdate$Response(params, context).pipe(
      map((r: StrictHttpResponse<WorkMessagingTemplate>): WorkMessagingTemplate => r.body)
    );
  }

}
